/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiConversationTractiveDiscountCodeRetrieve2Params } from './model/apiConversationTractiveDiscountCodeRetrieve2Params';
import type { TractiveDiscountCodeResponse } from './model/tractiveDiscountCodeResponse';

/**
 * Get tractive discount code if user meets eligibility criteria. Can be used with or without conversation context.
 */
export const apiConversationTractiveDiscountCodeRetrieve2 = (
  params?: ApiConversationTractiveDiscountCodeRetrieve2Params,
  signal?: AbortSignal
) => {
  return HTTP<TractiveDiscountCodeResponse>({
    url: `/api/v7/tractive-discount-code/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiConversationTractiveDiscountCodeRetrieve2QueryKey = (
  params?: ApiConversationTractiveDiscountCodeRetrieve2Params
) => {
  return [`/api/v7/tractive-discount-code/`, ...(params ? [params] : [])] as const;
};

export const getApiConversationTractiveDiscountCodeRetrieve2QueryOptions = <
  TData = Awaited<ReturnType<typeof apiConversationTractiveDiscountCodeRetrieve2>>,
  TError = ErrorType<unknown>
>(
  params?: ApiConversationTractiveDiscountCodeRetrieve2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiConversationTractiveDiscountCodeRetrieve2>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiConversationTractiveDiscountCodeRetrieve2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiConversationTractiveDiscountCodeRetrieve2>>
  > = ({ signal }) => apiConversationTractiveDiscountCodeRetrieve2(params, signal);

  return {
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiConversationTractiveDiscountCodeRetrieve2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiConversationTractiveDiscountCodeRetrieve2QueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationTractiveDiscountCodeRetrieve2>>
>;
export type ApiConversationTractiveDiscountCodeRetrieve2QueryError = ErrorType<unknown>;

export function useApiConversationTractiveDiscountCodeRetrieve2<
  TData = Awaited<ReturnType<typeof apiConversationTractiveDiscountCodeRetrieve2>>,
  TError = ErrorType<unknown>
>(
  params?: ApiConversationTractiveDiscountCodeRetrieve2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiConversationTractiveDiscountCodeRetrieve2>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiConversationTractiveDiscountCodeRetrieve2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
